import React, { useMemo } from 'react';
import AreaBar from './AreaBar';
import { IEntity } from 'interfaces/entity';

interface IProps {
  subTabValue?: number;
  areas: IEntity[];
  onChangeValue: (event: any, value: any) => void;
}

export default function SubTabsArea({ subTabValue, areas, onChangeValue }: IProps) {
  const subTabsArea = useMemo(() => (
    <AreaBar
      areas={areas}
      changeValue={onChangeValue}
      value={subTabValue}
      subTab
    />
  ), [areas, subTabValue, onChangeValue]);
  return subTabsArea;
}